export const navigateLevelUp = (match, history, num = 1) => {

  if (!match) {
    console.warn('Cannot navigate level up without match')
    return null
  }
  if (!history) {
    console.warn('Cannot navigate level up without history')
    return null
  }

  const parts = match.url.split('/')

  if (parts.length < num) {
    console.warn('Cannot navigate level up', num)
    return match.url
  }

  const newParts = parts.slice(0, parts.length - num)
  const newUrl = newParts.join('/')

  history && history.replace(newUrl)

  return newUrl
}

export const navigateUp = (match, history, previousLocation) => {
  if (!match) {
    console.warn('Cannot navigate without match')
    return null
  }
  if (!history) {
    console.warn('Cannot navigate without history')
    return null
  }

  if (match && match.params) {
    const collectionId = match.params ? match.params.collectionId : null
    const artistId = match.params ? match.params.artistId : null
    const index = match.params ? match.params.index : null

    if (index) {
      navigateLevelUp(match, history, 1)
    } else if (collectionId && artistId) {
      if (true || previousLocation) { // @NOTE: fixes issue 199
        navigateLevelUp(match, history, 2)
      } else {
        // Just go back to home! 
        history.replace('/')
      }
    } else if (collectionId || artistId) {
      navigateLevelUp(match, history, 2)
    } else {
      navigateLevelUp(match, history, 1)
    }
  } else {
    navigateLevelUp(match, history, 1)
  }
}
      



// WEBPACK FOOTER //
// ./src/lib/historyUtil.js